import { render, staticRenderFns } from "./resultPresent.vue?vue&type=template&id=59867458&scoped=true&"
import script from "./resultPresent.vue?vue&type=script&lang=js&"
export * from "./resultPresent.vue?vue&type=script&lang=js&"
import style0 from "./resultPresent.vue?vue&type=style&index=0&id=59867458&scoped=true&lang=css&"
import style1 from "./resultPresent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59867458",
  null
  
)

export default component.exports